import { StreamTimeSeriesState } from 'widgets/store/stream/WidgetStreamState';
import { KeyedStreamItem } from 'communication/types/StreamElement';
import {
    StreamsByStreamKeyState,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState';

export type SignalTileStreamState = StreamState<SignalTileDataState>;
export type SignalTileStreamsState =
    StreamsByStreamKeyState<SignalTileDataState>;

export type SignalTileDataState = StreamTimeSeriesState<SignalTileTimeElement>;

export type SignalTileTimeElement = KeyedStreamItem & SignalTileDataItemState;

export type SignalTileDataItemState = {
    value: number;
};

export const initialSignalTileDataState: SignalTileDataState = {
    timeSeries: [],
};

export const initialSignalTileStreamState: SignalTileStreamState = {
    data: initialSignalTileDataState,
    messages: [],
};

export const initialSignalTileStreamsState: SignalTileStreamsState = {};
